module.exports = __webpack_public_path__ + "img/button-detail.58df4070.svg";